export const testUriBase = "https://server.endgame-training.com/";
